export default __webpack_public_path__ + "static/techguru-example6-08b7c8686ba29630f8924d3dfc761509.jpg";